/**
 * The signed-out marker: a small cookie every server sign-out (/auth/signout) leaves in the browser's shared cookie jar.
 *
 * Why (batch 10-30a review R1-F1): a sign-out through the server form clears the auth cookie for every tab, but a tab that holds the
 * session in memory (lib/supabase/sessionKeeper) hears nothing. Without a marker that tab cannot tell "signed out elsewhere" from
 * "the browser dropped its cookie jar" (the #2030 case) and would hand the old session back. The marker says the first; a dropped
 * jar has none. It carries no identity and no secret, only the fact, and a new sign-in removes it.
 */
export const SIGNED_OUT_MARKER_COOKIE = 'neutralaiz-signed-out';

/** Long enough to outlast any offline spell of a call tab, short enough to tidy itself away. */
export const SIGNED_OUT_MARKER_MAX_AGE_S = 12 * 60 * 60;

/** True when the jar (a document.cookie string) holds the marker. */
export function signedOutMarkerIn(cookieString: string): boolean {
  return cookieString.split('; ').some((entry) => {
    const [name, value] = entry.split('=');
    return name === SIGNED_OUT_MARKER_COOKIE && Boolean(value);
  });
}

/** A new sign-in in this browser: the old sign-out no longer speaks for the jar. */
export function clearSignedOutMarker(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${SIGNED_OUT_MARKER_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}
